/**
 * @flow
 * @relayHash a9e71b0c730dc84156aaab1da7f68f80
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type TVShowApp_viewer$ref = any;
export type TVShowApp_Refetch_QueryVariables = {|
  page: number,
  isProject?: ?boolean,
  states?: ?$ReadOnlyArray<?string>,
|};
export type TVShowApp_Refetch_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: TVShowApp_viewer$ref
  |}
|};
export type TVShowApp_Refetch_Query = {|
  variables: TVShowApp_Refetch_QueryVariables,
  response: TVShowApp_Refetch_QueryResponse,
|};
*/


/*
query TVShowApp_Refetch_Query(
  $page: Int!
  $isProject: Boolean
  $states: [String]
) {
  viewer {
    ...TVShowApp_viewer_4ry37i
    id
  }
}

fragment TVShowApp_viewer_4ry37i on Viewer {
  tvshows: tvshowsPaginate(pageSize: 100, isProject: $isProject, page: $page, states: $states) {
    totalCount
    tvShows {
      id
      title
      categoryName
      order
      isProject
      state
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "page",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isProject",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "states",
    "type": "[String]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "TVShowApp_Refetch_Query",
  "id": null,
  "text": "query TVShowApp_Refetch_Query(\n  $page: Int!\n  $isProject: Boolean\n  $states: [String]\n) {\n  viewer {\n    ...TVShowApp_viewer_4ry37i\n    id\n  }\n}\n\nfragment TVShowApp_viewer_4ry37i on Viewer {\n  tvshows: tvshowsPaginate(pageSize: 100, isProject: $isProject, page: $page, states: $states) {\n    totalCount\n    tvShows {\n      id\n      title\n      categoryName\n      order\n      isProject\n      state\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "TVShowApp_Refetch_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "TVShowApp_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "isProject",
                "variableName": "isProject",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "states",
                "variableName": "states",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "TVShowApp_Refetch_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "tvshows",
            "name": "tvshowsPaginate",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "isProject",
                "variableName": "isProject",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page",
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "pageSize",
                "value": 100,
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "states",
                "variableName": "states",
                "type": "[String]"
              }
            ],
            "concreteType": "TVShowsPagination",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalCount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tvShows",
                "storageKey": null,
                "args": null,
                "concreteType": "TVShow",
                "plural": true,
                "selections": [
                  v1,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "categoryName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "order",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isProject",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "state",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          v1
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '42ed516c2639a22ece9895ec95439361';
module.exports = node;



// WEBPACK FOOTER //
// src/components/tvshow/__generated__/TVShowApp_Refetch_Query.graphql.js